import { useTranslation } from 'react-i18next';
import { ChevronRightIcon } from '@heroicons/react/20/solid';

import { Alert, AlertSection } from 'components/Display/Alert';

import { DocumentTypeSetting } from '../../pages/TradePartners/helpers';

type UnsupportedDocumentTypesMessageProps = {
  documentTypeSettings: Array<DocumentTypeSetting>;
  onRequestUnavailableDocuments: () => void;
};

export function UnsupportedDocumentTypesMessage({
  documentTypeSettings,
  onRequestUnavailableDocuments,
}: UnsupportedDocumentTypesMessageProps) {
  const { t } = useTranslation();

  const hasUnavailableDocuments = documentTypeSettings.some(
    (setting) => setting.incoming.currentStatus === 'notAvailable' || setting.outgoing.currentStatus === 'notAvailable',
  );

  if (!hasUnavailableDocuments) {
    return null;
  }

  return (
    <Alert
      withoutIcon
      fullWidth
      severity="neutral"
      className="rounded-md border-none !px-4"
      actions={{
        alignment: 'right',
        primary: {
          variant: 'minimal',
          children: t('partners:request.documentTypeRequest.cta.button'),
          onClick: onRequestUnavailableDocuments,
          RightIcon: ChevronRightIcon,
          analyticsId: 'connections:request_unsupported_document_type',
        },
      }}
    >
      <AlertSection severity="neutral" title={t('partners:request.documentTypeRequest.cta.title')}>
        <p className="leading-5">{t('partners:request.documentTypeRequest.cta.description')}</p>
      </AlertSection>
    </Alert>
  );
}
